<template>
  <div id="InfoProgram">
    <md-dialog :md-active.sync="showDialog" :md-click-outside-to-close="false" :md-close-on-esc="false">

      <div style="width:100%; padding:5px">
      <!-- <md-button class="md-primary" style="position: relative; width: 80px; float: right;" @click="closeDialog(0)">Zamknij</md-button> -->
      <button class="btn btn-default" @click="closeDialog(0)"
      style="float: right; margin: 5px 34px; color:#007bff;background:#fff;border:1px solid #007bff">{{$t('message.zamknij')}}</button>
      </div>
      <md-dialog-title>{{$t('message.wyslij_zapytanie')}}</md-dialog-title>
      <div id="content">

        <form>
          <div class="wiersz">

            <div class="kolumny">
              <div class="form-grupa">
                <label for="staticNazwa" class="col-form-label">{{$t('message.nazwa_firmy')}}:</label>
                <input type="text" class="form-control form-control-sm" id="staticNazwa">
              </div>
              <div class="form-grupa">
                <label for="staticNazwa" class="col-form-label">{{$t('message.imie')}}:</label>
                <input type="text" class="form-control form-control-sm" id="staticNazwa">
              </div>
              <div class="form-grupa">
                <label for="inputAdres" class="col-form-label">{{$t('message.adres')}}:</label>
                <input type="text" class="form-control form-control-sm" id="inputAdres">
              </div>
              <div class="form-grupa">
                <label for="inputMiasto" class="col-form-label">{{$t('message.miasto')}}:</label>
                <input type="text" class="form-control form-control-sm" id="inputKod" style="width: 20%; float: left; margin-right: 4%;">
                <input type="text" class="form-control form-control-sm" id="inputMiasto" style="width: 76%; float: left;">
              </div>
              <div class="form-grupa">
                <label for="inputTelefon" class="col-form-label">{{$t('message.telefon')}}:</label>
                <input type="text" class="form-control form-control-sm" id="inputTelefon">
              </div>
              <div class="form-grupa">
                <label for="inputMail" class="col-form-label">{{$t('message.email')}}:</label>
                <input type="text" class="form-control form-control-sm" id="inputMail">
              </div>
              <div class="form-grupa">
                <label for="inputNIP" class="col-form-label">{{$t('message.stanowisko')}}:</label>
                <input type="text" class="form-control form-control-sm" id="inputNIP">
              </div>
            </div>
            <div class="kolumny">
              <div class="form-grupa">
                <label for="staticNazwa" class="col-form-label">{{$t('message.tresc')}}:</label>
                <textarea class="form-control form-control-sm" id="staticNazwa" rows="10" cols="33"></textarea>
              </div>
            </div>

          </div>

          <button class="btn btn-primary" style="float: right; margin: 10px 34px;">{{$t('message.wyslij')}}</button>

        </form>

      </div>
    </md-dialog>
  </div>
</template>

<script>
export default {
  name: 'InfoProgram',
  props: ['showDialog'],
  data () {
    return {
      innyAdres: false
    }
  },
  methods: {
    closeDialog () {
      this.$emit('clickedClose', false)
    }
  }
}
</script>

<style scoped>
.row {
  margin: 15px;
}
.wiersz {
  width: 100%;
  height: 400px;
  padding: 0px 15px;
  display: inline-flex;
}
.kolumny{
  width:46%;
}
.kolumny:first-child{
  margin-left:2%;
  margin-right:4%
}
.md-dialog-title {
    margin-bottom: 10px;
    padding: 0px 36px 0;
}
div.md-dialog {
  background: rgba(0,0,0,0.6);
}
div.md-dialog div {
  /* background: rgb(255, 255, 255);
  width: 920px;
  max-width: 920px;
  padding: 10px; */
}
#content {
  /* font-size: 16px;
  line-height: 24px;
  height: 480px; */
}
div.form-grupa {
  width:100%;
  margin-bottom: 8px;
  height: 52px;
}
div.form-grupa label {
  width:100%;padding: 0px 4px;
}
.form-check {
width: 100%;
text-align: right;
margin-right: 50px;
position: relative;
right: 40px;
bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dialogs/Zapytanie.vue